class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    FacetFiltersForm.renderMobileFacets(searchParams, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

    static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // NEW: re‑initialize infinite scroll after filters/sorting re‑render the grid
    if (window.initCollectionInfiniteScroll) {
      window.initCollectionInfiniteScroll();
    }
  }


  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    // Perf: when the mobile drawer list is deferred, the grid section's response has no mobile
    // filters. Leave the drawer's (lazily loaded) filters alone here; renderMobileFacets updates them.
    const filterSelector = FacetFiltersForm.isMobileFacetsDeferred(parsedHTML)
      ? '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
      : '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter';
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(filterSelector);
    const facetDetailsElementsFromDom = document.querySelectorAll(filterSelector);

    const countsToRender = FacetFiltersForm.renderFilterElements(
      facetDetailsElementsFromFetch,
      facetDetailsElementsFromDom,
      event
    );
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.renderInteractedFilterCounts(countsToRender, event);
  }

  static renderFilterElements(facetDetailsElementsFromFetch, facetDetailsElementsFromDom, event) {
    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const parentInDom = document.getElementById(elementToRender.parentElement.id);
          const firstFilterInDom = parentInDom && parentInDom.querySelector('.js-filter');
          if (firstFilterInDom) {
            firstFilterInDom.before(elementToRender);
          } else if (parentInDom) {
            parentInDom.prepend(elementToRender);
          }
        }
      }
    });

    return countsToRender;
  }

  static renderInteractedFilterCounts(countsToRender, event) {
    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  // Perf (lazy mobile filters): when #FacetsWrapperMobile has data-deferred-section, the drawer's
  // filter list is not in the page HTML (snippets/facets.liquid). It is fetched from that
  // standalone section (sections/facets-mobile-drawer.liquid) via the Section Rendering API the
  // first time the drawer opens, and refreshed after every filter change once loaded.
  static getDeferredMobileWrapper() {
    return document.querySelector('#FacetsWrapperMobile[data-deferred-section]');
  }

  static isMobileFacetsDeferred(doc) {
    return Boolean(doc.querySelector('#FacetsWrapperMobile[data-deferred-section]'));
  }

  static fetchMobileFacets(wrapper, searchParams) {
    const url = `${window.location.pathname}?section_id=${wrapper.dataset.deferredSection}${
      searchParams ? `&${searchParams}` : ''
    }`;
    const cached = FacetFiltersForm.filterData.find((element) => element.url === url);
    if (cached) return Promise.resolve(cached.html);

    return fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Mobile filters request failed (${response.status})`);
        return response.text();
      })
      .then((html) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        return html;
      });
  }

  static parseMobileFacets(html, wrapper) {
    const fetchedWrapper = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetsWrapperMobile');
    if (!fetchedWrapper || fetchedWrapper.hasAttribute('data-deferred-section')) return null;
    if (wrapper.dataset.enableSorting === 'false') {
      fetchedWrapper.querySelectorAll('[id^="Details-Mobile-SortBy-"]').forEach((element) => element.remove());
    }
    return fetchedWrapper;
  }

  static bindMobileFacetEvents(wrapper) {
    // Same listeners MenuDrawer.bindEvents() adds, but only once per element.
    const drawer = wrapper.closest('menu-drawer');
    if (!drawer || typeof drawer.onSummaryClick !== 'function') return;
    const bound = FacetFiltersForm.boundMobileElements;
    wrapper.querySelectorAll('summary').forEach((summary) => {
      if (bound.has(summary)) return;
      bound.add(summary);
      summary.addEventListener('click', drawer.onSummaryClick.bind(drawer));
    });
    wrapper.querySelectorAll('button').forEach((button) => {
      if (bound.has(button)) return;
      bound.add(button);
      button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer));
    });
  }

  static loadMobileFacets() {
    const wrapper = FacetFiltersForm.getDeferredMobileWrapper();
    if (!wrapper) return;
    const state = wrapper.dataset.deferredState;
    if (state === 'loading' || state === 'loaded') return;

    if (state === 'error') FacetFiltersForm.showMobileFacetsStatus(wrapper, false);
    wrapper.dataset.deferredState = 'loading';
    wrapper.setAttribute('aria-busy', 'true');
    const searchParams = FacetFiltersForm.searchParamsPrev;

    FacetFiltersForm.fetchMobileFacets(wrapper, searchParams)
      .then((html) => {
        const fetchedWrapper = FacetFiltersForm.parseMobileFacets(html, wrapper);
        if (!fetchedWrapper) throw new Error('Mobile filters missing from section response');

        wrapper.innerHTML = fetchedWrapper.innerHTML;
        wrapper.dataset.deferredState = 'loaded';
        wrapper.removeAttribute('aria-busy');
        FacetFiltersForm.bindMobileFacetEvents(wrapper);

        // Filters changed (e.g. a pill was removed) while this was loading: catch up.
        if (searchParams !== FacetFiltersForm.searchParamsPrev) {
          FacetFiltersForm.renderMobileFacets(FacetFiltersForm.searchParamsPrev, null);
        }

        // MenuDrawer set up its focus trap before the list existed; redo it with the new controls.
        const details = wrapper.closest('details');
        if (details && details.hasAttribute('open') && typeof trapFocus === 'function') {
          const active = document.activeElement;
          trapFocus(details, details.contains(active) ? active : details.querySelector('summary'));
        }
      })
      .catch(() => {
        wrapper.dataset.deferredState = 'error';
        wrapper.removeAttribute('aria-busy');
        FacetFiltersForm.showMobileFacetsStatus(wrapper, true);
      });
  }

  static showMobileFacetsStatus(wrapper, isError) {
    const status = wrapper.querySelector('.mobile-facets__deferred');
    if (!status) return;
    const spinner = status.querySelector('.mobile-facets__deferred-spinner');
    const text = status.querySelector('.mobile-facets__deferred-text');
    if (spinner) spinner.classList.toggle('hidden', isError);
    if (!text) return;
    if (!text.dataset.loadingText) text.dataset.loadingText = text.textContent;
    if (!isError) {
      text.textContent = text.dataset.loadingText;
      return;
    }
    text.textContent = `${wrapper.dataset.errorText || ''} `;
    const reload = document.createElement('a');
    reload.href = window.location.href;
    reload.className = 'underlined-link';
    reload.textContent = wrapper.dataset.reloadText || 'reload';
    text.append(reload, '.');
  }

  static renderMobileFacets(searchParams, event) {
    const wrapper = FacetFiltersForm.getDeferredMobileWrapper();
    // Not opened yet: nothing to update. The first open fetches the then-current filters.
    if (!wrapper || wrapper.dataset.deferredState !== 'loaded') return;

    FacetFiltersForm.fetchMobileFacets(wrapper, searchParams)
      .then((html) => {
        // A newer filter change has started since; its own refresh will render.
        if (searchParams !== FacetFiltersForm.searchParamsPrev) return;
        const fetchedWrapper = FacetFiltersForm.parseMobileFacets(html, wrapper);
        if (!fetchedWrapper) return;
        const countsToRender = FacetFiltersForm.renderFilterElements(
          fetchedWrapper.querySelectorAll('.js-filter'),
          wrapper.querySelectorAll('.js-filter'),
          event
        );
        FacetFiltersForm.bindMobileFacetEvents(wrapper);
        FacetFiltersForm.renderInteractedFilterCounts(countsToRender, event);
      })
      .catch(() => {});
  }

  static initDeferredMobileFacets() {
    const wrapper = FacetFiltersForm.getDeferredMobileWrapper();
    const details = wrapper && wrapper.closest('details');
    const summary = details && details.querySelector('summary');
    if (!summary) return;

    const load = () => FacetFiltersForm.loadMobileFacets();
    // Start on intent (finger down / keyboard) so the list is usually in place by the time the
    // drawer has finished sliding in; 'toggle' covers any other way the drawer gets opened.
    summary.addEventListener('pointerdown', load);
    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') load();
    });
    details.addEventListener('toggle', () => {
      if (details.open) load();
    });
    if (details.open) load();
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.boundMobileElements = new WeakSet();
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.initDeferredMobileFacets();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
